import React, { Component } from 'react';

class ListadoRubros extends Component {
    constructor(props) {
        super(props);
    }

    render() {

        return (
            <div className="top-separator-xs">
                <ul className="no-bullets no-padding no-margin">
                    {this.props.rubrosList}
                </ul>
            </div>);
    }
};

export default ListadoRubros;